<template>
  <div class="SoftwareProduct">
    <div class="title">
      <span>软件下载</span>
      <span>SOFTWARE DOWNLOAD</span>
    </div>
    <div class="box1">
      <!-- <div>
        <el-popover placement="top" trigger="hover">
          <div class="popover">
            <div class="qrcodebox">
              <img src="@/assets/SoftwareProduct/YHB.png" />
              <div class="tit">用户版</div>
            </div>
            <div class="qrcodebox2">
              <img src="@/assets/SoftwareProduct/YSB.png" />
              <div class="tit">医生版</div>
            </div>
          </div>
          <div
            slot="reference"
            class="download"
            @mouseover="mouseover(0)"
            @mouseleave="mouseleave(0)"
          >
            <img :src="androidSrc" />
          </div>
        </el-popover>
        <div
          slot="reference"
          class="download"
          @mouseover="mouseover(1)"
          @mouseleave="mouseleave(1)"
        >
          <img :src="iosSrc" />
        </div>
      </div> -->
      <div>
        <div>
          <div class="qrcodebox">
            <img src="@/assets/SoftwareProduct/android_user.png" />
            <p class="tit">用户版</p>
          </div>
          <div class="qrcodebox">
            <img src="@/assets/SoftwareProduct/android_doctor.png" />
            <p class="tit">医生版</p>
          </div>
        </div>
        <div class="downloadTitle">
          <img :src="androidSrc" />
          <p>Android</p>
        </div>
      </div>
      <div>
        <div>
          <div class="qrcodebox">
            <img src="@/assets/SoftwareProduct/ios_user.png" />
            <p class="tit">用户版</p>
          </div>
          <div class="qrcodebox">
            <img src="@/assets/SoftwareProduct/ios_doctor.png" />
            <p class="tit">医生版</p>
          </div>
        </div>
        <div class="downloadTitle">
          <img :src="iosSrc" />
          <p>iPhone</p>
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="title">
        <span>软件介绍</span>
        <span>COMPANY INTRODUCTION</span>
      </div>
      <div class="softwareIntroduction">
        <el-tabs v-model="activeName" ref="tabs" stretch>
          <el-tab-pane label="灏睿云医用户版" name="0"
            >灏睿云医APP用户版，为您提供便捷的医疗服务体验。通过灏睿云医APP用户版，您可以轻松进行在线挂号、复诊预约，查看检查报告，实现随时随地的在线问诊，并管理个人健康档案。我们致力于提供全方位的医疗服务，让您更轻松地与医生沟通，获得更智能、贴心的健康管理。随时随地，我们与您同行，为您的健康保驾护航。</el-tab-pane
          >
          <el-tab-pane label="灏睿云医医生版" name="1"
            >灏睿云医APP医生版，为医生提供一站式智能医疗服务。灏睿云医APP医生版，医生能够轻松进行接诊管理，实现远程视频看诊，便捷开具检查、化验单和处方，实现全方位的患者治疗。同时，我们与医院系统实现紧密对接，确保医疗信息的及时同步。这一全面的医疗工具旨在提高医生的工作效率，使医疗服务更加智能、高效。感谢您选择我们的远程医疗APP医生端，共同致力于为患者提供更优质、便捷的医疗体验。
          </el-tab-pane>
          <el-tab-pane label="智慧医疗云门诊工作站" name="2">
            智慧医疗云门诊工作站，为患者提供一体化的医疗服务。云门诊工作站不仅支持基本的在线挂号、视频就诊、检查报告查看等功能，更为特别的是其内置的实时体征检测功能。在视频就诊时，患者可以方便地完成血压、体温、脉搏等时间部分检测，为医生提供更详尽的患者状况反馈，助力医生更准确地了解患者的身体状况并提供精准的医疗建议。同时，工作站与医院、药房等系统关联，支持一站式服务，让患者在同一个平台上完成缴费、检查化验单开具和取药等步骤。我们致力于为患者打造更大屏幕、更丰富功能的智能医疗体验，提供更便捷、贴心的医疗服务。感谢您选择我们的服务，共同迈向智能医疗的未来。</el-tab-pane
          >
        </el-tabs>
        <!-- <div
          style="
            background: black;
            color: #fff;
            font-size: 28px;
            text-align: center;
            line-height: 300px;
          "
        >
          图片找香坤要
        </div>
        <div>
          <h1>灏睿云医</h1>
          <p>
            灏睿云医为医生和患者提供的在线远程门诊平台通过云医生能够实现医生与患者之间随时门诊，同时可以通过远程会诊功能，与其他医生一同讨论病案。通过资源的整合和价值营销引导患者到正确的医院找正确的医生就诊，避免医疗资源的过度浪费。
          </p>
        </div> -->
      </div>
    </div>
    <div class="box3">
      <div class="title">
        <span>操作手册</span>
        <span>OPERATION MANUAL</span>
      </div>
      <div class="operationManual">
        <div>
          <div>
            <span>OPERATIONMANUAL</span>
            <span>灏睿云医操作手册</span>
          </div>
        </div>
        <ul>
          <li v-for="item in operationList" :key="item.id">
            <span>
              {{ item.content }}
            </span>
            <span>
              <span @click="check(item)">查看</span>
              <span>|</span>
              <span @click="download(item)">下载</span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { videoDownload } from "@/utils/downloadFile";
import QRCode from "qrcodejs2";
// import axios from "axios";
export default {
  name: "SoftwareProduct",
  data() {
    return {
      activeName: "0",
      androidSrc: require("@/assets/SoftwareProduct/android2.png"),
      android: require("@/assets/SoftwareProduct/android.png"),
      android_hover: require("@/assets/SoftwareProduct/android_hover.png"),
      iosSrc: require("@/assets/SoftwareProduct/ios2.png"),
      ios: require("@/assets/SoftwareProduct/ios.png"),
      ios_hover: require("@/assets/SoftwareProduct/ios_hover.png"),
      url: "",
      url2: "",
      operationList: [
        {
          url: "https://hospital-images.obs.cn-north-1.myhuaweicloud.com/yygzzsysc.pdf",
          content: "云医工作站使用手册",
          fileFormat: "application/pdf",
        },
        {
          url: "https://hospital-images.obs.cn-north-1.myhuaweicloud.com/yygzzsysc.mp4",
          content: "云医工作站使用手册(视频)",
          fileFormat: "video/mp4",
        },
        {
          url: "https://hospital-images.obs.cn-north-1.myhuaweicloud.com/hryysyzn.pdf",
          content: "灏睿云医APP使用指南",
          fileFormat: "application/pdf",
        },
        {
          url: "https://hospital-images.obs.cn-north-1.myhuaweicloud.com/hryysyzn.mp4",
          content: "灏睿云医APP使用指南(视频)",
          fileFormat: "video/mp4",
        },
        {
          url: "https://hospital-images.obs.cn-north-1.myhuaweicloud.com/hryyysbsyzn.pdf",
          content: "灏睿云医APP医生版使用指南",
          fileFormat: "application/pdf",
        },
        {
          url: "https://hospital-images.obs.cn-north-1.myhuaweicloud.com/hryyysbsyzn.mp4",
          content: "灏睿云医APP医生版使用指南(视频)",
          fileFormat: "video/mp4",
        },
      ],
    };
  },
  watch: {
    currentLang() {
      console.log("123");
      this.resetTabActivePosition(this.$refs.tabs.$el);
    },
  },
  created() {
    // axios({
    //   url: "https://api.haoruiyunyi.com/synthetical/versions/pub/getVersionsFirst",
    //   methods: "get",
    //   params: {
    //     appType: 1,
    //   },
    // }).then((res) => {
    //   this.url = "https://obs-prod.haoruiyunyi.com/" + res.data.data.url;
    //   console.log(this.url);
    //   this.qrcode();
    // });
    // axios({
    //   url: "https://api.haoruiyunyi.com/synthetical/versions/pub/getVersionsFirst",
    //   methods: "get",
    //   params: {
    //     appType: 4,
    //   },
    // }).then((res) => {
    //   this.url2 = "https://obs-prod.haoruiyunyi.com/" + res.data.data.url;
    //   console.log(this.url2);
    //   this.qrcode2();
    // });
  },
  methods: {
    resetTabActivePosition($el) {
      this.$nextTick(() => {
        const activeEl = $el.querySelector(".el-tabs__item.is-active");
        const lineEl = $el.querySelector(".el-tabs__active-bar");
        const style = getComputedStyle(activeEl);
        const pl = style.paddingLeft.match(/\d+/)[0] * 1;
        const pr = style.paddingRight.match(/\d+/)[0] * 1;
        const w = style.width.match(/\d+/)[0] * 1;
        lineEl.style.transform =
          "translateX(" + (activeEl.offsetLeft + pl) + "px)";
        lineEl.style.width = w - pl - pr + "px";
      });
    },
    mouseover(val) {
      if (val == 0) {
        this.androidSrc = this.android_hover;
      } else if (val == 1) {
        this.iosSrc = this.ios_hover;
      }
    },
    mouseleave(val) {
      if (val == 0) {
        this.androidSrc = this.android;
      } else if (val == 1) {
        this.iosSrc = this.ios;
      }
    },
    //用户版
    qrcode() {
      let qrcode = new QRCode("qrcode", {
        width: 150,
        height: 150,
        text: this.url, // 二维码地址
      });
      console.log(qrcode);
    },
    //医生版
    qrcode2() {
      let qrcode2 = new QRCode("qrcode2", {
        width: 150,
        height: 150,
        text: this.url2, // 二维码地址
      });
      console.log(qrcode2);
    },
    //查看
    check(val) {
      window.open(val.url);
    },
    //下载
    download(val) {
      videoDownload(val.url, val.content, val.fileFormat);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index.scss";
</style>